import React from "react";
import { motion } from "framer-motion";

export const easeLux = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: easeLux }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Signature masked line-by-line reveal for hero headlines
export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14 }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.15, delay: delay + i * stagger, ease: easeLux }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </span>
);
